import React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { MdFileUpload } from 'react-icons/md';
import { BoardModal } from './boardModal/BoardModal';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${theme.palette.coal};
  margin-bottom: 16px;
`;

interface Props {
  boardType?: string;
}
export const EmptyBoards = ({ boardType = 'owned' }: Props) => {
  const { t } = useTranslation();
  const [showCreateBoardModal, setShowCreateBoardModal] = React.useState(false);
  const emptyTitle =
    boardType === 'owned'
      ? t("You don't have created Boards.")
      : t("You don't have shared Boards.");

  return (
    <Container>
      <Title>{emptyTitle}</Title>
      {boardType === 'owned' && (
        <Button
          text={t('Create Board')}
          icon={<MdFileUpload size='18px' />}
          onClick={() => setShowCreateBoardModal(true)}
        />
      )}

      {showCreateBoardModal && (
        <BoardModal handleModalClose={() => setShowCreateBoardModal(false)} />
      )}
    </Container>
  );
};
